import { jsx } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import styles from "./Input.module.scss.js";
const inputVariants = cva(
  [
    styles["input"],
    "block leading-normal rounded-md w-full focus:border-primary focus:outline focus:outline-2 focus:outline-primary/10"
  ],
  {
    variants: {
      invalid: {
        true: [styles["invalid"], "outline outline-danger/10 focus:border-danger focus:outline-danger/10"],
        false: []
      },
      valid: {
        true: [styles["valid"], "outline outline-success/10 focus:border-success focus:outline-success/10"],
        false: []
      },
      disabled: {
        true: [styles["disabled"], "opacity-50"],
        false: []
      }
    },
    defaultVariants: {
      disabled: false,
      invalid: false,
      valid: false
    }
  }
);
const Input = forwardRef((props, ref) => {
  const { invalid, valid, disabled, className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "input",
    {
      ...rest,
      ref,
      disabled,
      className: twMerge(inputVariants({ invalid, valid, disabled, className }))
    }
  );
});
export {
  Input as default
};
//# sourceMappingURL=Input.js.map
